import { render } from "./CarrierSelectionStep.vue?vue&type=template&id=36992fac"
import script from "./CarrierSelectionStep.vue?vue&type=script&lang=ts"
export * from "./CarrierSelectionStep.vue?vue&type=script&lang=ts"
script.render = render

export default script